module.exports = __webpack_public_path__ + "static/media/cross.a39cb44a.svg";